import { CalendarIcon, FlagIcon, Icon, Pane, Text, TimeIcon } from 'evergreen-ui';
import styled from 'styled-components';

const StyledText = styled(Text)`
  color: #e9ebed;
  font-weight: 500;
`;
const commonStyle = {
  display: 'flex',
  alignItems: 'center',
};

const ShiftsListItem = ({ item }) => {
  return (
    <Pane
      background="#2B2D2E"
      boxShadow="0px 20px 70px rgba(0, 0, 0, 0.3)"
      borderRadius={16}
      display="flex"
      flexDirection="column"
      paddingX={24}
      paddingY={22}
      marginX={20}
      marginY={10}
      flex={1}
    >
      <div>
        <StyledText>{item.title}</StyledText>
      </div>
      <div style={{ ...commonStyle, marginTop: 15 }}>
        <Icon size={24} color="#65696C" paddingRight={15} icon={CalendarIcon} />
        <StyledText>{item.date}</StyledText>
      </div>
      <div style={{ ...commonStyle, marginTop: 15 }}>
        <div style={{ ...commonStyle, flex: 1 }}>
          <Icon size={24} color="#65696C" paddingRight={15} icon={TimeIcon} />
          <StyledText>{item.timeStart}</StyledText>
        </div>
        <div style={{ ...commonStyle, flex: 1 }}>
          <Icon size={24} color="#65696C" paddingRight={15} icon={FlagIcon} />
          <StyledText>{item.timeEnd}</StyledText>
        </div>
      </div>
    </Pane>
  );
};

export default ShiftsListItem;
